import { useState } from "react";

// ── Data ──────────────────────────────────────────────────────────────────────

const HEAD_OFFICE = {
  country: "INDIA",
  company: "TK Sports Pvt. Ltd.",
  address: ["407 Leather Complex, Kapurthala Road,", "Jalandhar — 144021, Punjab"],
  phones: ["0181-5006935", "+91-98030-21407"],
  email: "myteam@tyka.com",
  mapSrc:
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6815.901299586198!2d75.52190500635106!3d31.332735984919786!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a454ccf55ec8b%3A0xecbbc58782e2fe6e!2sTK%20Sports%20Pvt%20Ltd%20%7C%20TYKA!5e0!3m2!1sen!2sin!4v1698231533131!5m2!1sen!2sin",
  mapLink: "https://maps.google.com/?q=TK+Sports+Pvt+Ltd+TYKA+Jalandhar",
};

const DEALERS = [
  {
    region: "NEW ZEALAND",
    company: "FREEDOM2PLAY",
    address: ["429, Hillsborough Sports, Hillsborough, Auckland - 1042"],
    phones: ["+64 27 3733366"],
    email: "tykanz@tyka.com",
    mapSrc: "https://www.google.com/maps?q=429%20Hillsborough%20Auckland&output=embed",
    mapLink: "https://maps.google.com/?q=429 Hillsborough Auckland",
  },
  {
    region: "USA",
    company: "CRICMAX",
    address: ["440, Bordentown Ave, Sayreville, NJ 08872"],
    phones: ["+1 551 580 0453"],
    email: "clothing@cricmax.com",
    mapSrc: "https://www.google.com/maps?q=CricMax%20Sports%20Facility%20Sayreville&output=embed",
    mapLink: "https://maps.google.com/?q=CricMax Sports Facility Sayreville NJ",
  },
  {
    region: "AUSTRALIA",
    company: "TYKA SPORTS AU",
    address: ["Dandenong, Victoria"],
    phones: ["NaN"],
    email: "sales@tyka.com.au",
    mapSrc: "https://www.google.com/maps?q=Dandenong%20Victoria&output=embed",
    mapLink: "https://maps.google.com/?q=Dandenong Victoria Australia",
  },
  {
    region: "UNITED KINGDOM",
    company: "TYKA SPORTS UK",
    address: [],
    phones: ["+44 7825 175 417"],
    email: "sales@tyka.co.uk",
    mapSrc: "https://www.google.com/maps?q=United%20Kingdom&output=embed",
    mapLink: "https://maps.google.com/?q=United Kingdom",
  },
];

// ── Icons ─────────────────────────────────────────────────────────────────────

function LocationIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      className="shrink-0 mt-0.5 text-gray-500"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
        fill="currentColor"
      />
    </svg>
  );
}

function BagIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="text-gray-400"
    >
      <path d="M20 6h-2.18c.07-.44.18-.88.18-1.36C18 2.51 16.49 1 14.64 1H9.36C7.51 1 6 2.51 6 4.64c0 .48.11.92.18 1.36H4C2.9 6 2 6.9 2 8v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5.82-1.27C14.42 4.37 14.08 4 13.64 4H10.36c-.44 0-.78.37-.54.73l.64 1.27H9.18c-.05-.22-.18-.47-.18-.73C9 3.67 9.67 3 10.36 3h3.28c.69 0 1.36.67 1.36 1.27 0 .26-.13.51-.18.73h-1.28l.64-1.27zM20 19H4V8h16v11z" />
    </svg>
  );
}

// ── Sub-components ────────────────────────────────────────────────────────────

function MapEmbed({ src, height = 240 }) {
  return (
    <iframe
      src={src}
      width="100%"
      height={height}
      className="block w-full mt-3 rounded border border-gray-200"
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="map"
    />
  );
}

function DealerCard({ dealer, isLastInRow, isLastRow }) {
  return (
    <div
      className={[
        "p-5",
        !isLastInRow ? "border-r border-gray-200" : "",
        !isLastRow ? "border-b border-gray-200" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {/* Region heading */}
      <h3 className="text-xl font-bold text-black mb-2.5 leading-snug">
        TYKA : {dealer.region}
      </h3>

      {/* Company name */}
      <div className="flex items-start gap-1.5 text-s font-bold text-black uppercase tracking-wide mb-1.5">
        <LocationIcon />
        <span>{dealer.company}</span>
      </div>

      {/* Address lines */}
      {dealer.address.map((line, i) => (
        <p key={i} className="text-sm leading-relaxed text-black">
          {line}
        </p>
      ))}

      {/* Phones */}
      {dealer.phones.map((p, i) => (
        <p key={i} className="text-sm leading-relaxed text-black">
          {p}
        </p>
      ))}

      {/* Email */}
      {dealer.email && (
        <a
          href={`mailto:${dealer.email}`}
          className="text-sm text-black hover:underline block mt-0.5"
        >
          {dealer.email}
        </a>
      )}

      {/* Map */}
      <MapEmbed src={dealer.mapSrc} height={280}  />
    </div>
  );
}

function RowDivider() {
  return (
    <div className="col-span-3 relative flex items-center justify-center h-px">
      <div className="w-full h-px bg-gray-200" />
      <div className="absolute bg-white px-2.5 flex items-center justify-center">
        <BagIcon />
      </div>
    </div>
  );
}

// ── Main Page ─────────────────────────────────────────────────────────────────

export default function DealersPage() {
  const rows = [];
  for (let i = 0; i < DEALERS.length; i += 3) {
    rows.push(DEALERS.slice(i, i + 3));
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-10 pb-20">

      {/* ── Head Office ── */}
      <h1 className="text-2xl font-bold text-gray-900 mb-3.5">
        Head Office : India
      </h1>

      <div className="flex items-start gap-1.5 text-sm font-semibold text-gray-900 mb-1">
        <LocationIcon />
        <span className="font-bold">{HEAD_OFFICE.company}</span>
      </div>

      {HEAD_OFFICE.address.map((line, i) => (
        <p key={i} className="text-sm leading-relaxed text-black">
          {line}
        </p>
      ))}

      <p className="text-sm text-black mb-0.5">
        {HEAD_OFFICE.phones.join(", ")}
      </p>

      <a
        href={`mailto:${HEAD_OFFICE.email}`}
        className="text-sm text-black hover:underline"
      >
        {HEAD_OFFICE.email}
      </a>

      <MapEmbed src={HEAD_OFFICE.mapSrc} height={340} />

      {/* ── Section Divider ── */}
      <div className="flex items-center gap-2.5 my-8 text-gray-400 text-[11px] tracking-widest uppercase font-medium">
        <div className="flex-1 h-px bg-gray-200" />
        <span>Global Dealers</span>
        <div className="flex-1 h-px bg-gray-200" />
      </div>

      {/* ── Dealer Grid ── */}
      <div className="grid grid-cols-3 border border-gray-200 rounded-lg overflow-hidden">
        {rows.map((row, rowIdx) => (
          <>
            {row.map((dealer, colIdx) => (
              <DealerCard
                key={dealer.region}
                dealer={dealer}
                isLastInRow={colIdx === row.length - 1 || colIdx === 2}
                isLastRow={rowIdx === rows.length - 1}
              />
            ))}
            {rowIdx < rows.length - 1 && (
              <RowDivider key={`div-${rowIdx}`} />
            )}
          </>
        ))}
      </div>

    </div>
  );
}
